export default __webpack_public_path__ + "static/media/netflix.75081d61.jpg";